// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timeline-item>.v-list-group>.v-list-group__items>.v-list-item{padding-left:2rem}", ""]);
// Exports
module.exports = exports;
